import * as R from 'ramda';
import * as htmlToImage from 'html-to-image';
import { copyImageToClipboard } from '@/utils/clipboard';
import { getEvolutionsTableFields } from '@/utils/transformers';
import { REVENUE_EXCL_VAT_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD, SPONSORED_SALES_FIELD, SPEND_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD, LISTED_ASIN_FIELD, PAGE_VIEWS_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVG_BSR_FIELD, RETURN_RATE_FIELD, PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD, ORGANIC_SALES_FIELD } from "../utils/table_fields";
// Custom HTML Legend Plugin
export default {
  data() {
    return {
      TABBED_FIELDS: {
        performance: [REVENUE_EXCL_VAT_FIELD, TOTAL_QUANTITY_FIELD, AVERAGE_UNIT_PRICE_FIELD, DAYS_INVENTORY_FIELD, LOST_REVENUE_EXCL_VAT_FIELD, ORGANIC_CVR_FIELD, BUYBOX_FIELD, PPC_SALES_FIELD, TACOS_FIELD],
        advertising: [SPONSORED_SALES_FIELD, SPEND_FIELD, TACOS_FIELD, CLICKS_FIELD, CPC_FIELD, UNITS_SOLD_FIELD, CVR_FIELD, BAR_ROAS_FIELD, SPONSORED_ASIN_FIELD],
        listing: [LISTED_ASIN_FIELD, PAGE_VIEWS_FIELD, TOTAL_QUANTITY_FIELD, ORGANIC_CVR_FIELD, RATING_FIELD, RATING_TOTAL_FIELD, AVERAGE_UNIT_PRICE_FIELD, AVG_BSR_FIELD, RETURN_RATE_FIELD, BUYBOX_FIELD, ORGANIC_SALES_FIELD],
        profit: [PROFIT_REVENUE_FIELD, PROFIT_CONTRIBUTIVE_MARGIN_FIELD, PROFIT_PERCENTAGE_OF_REVENUE_FIELD, PROFIT_COMMISSION_FIELD, PROFIT_FBA_DIRECT_FIELD, PROFIT_FBA_INDIRECT_FIELD, PROFIT_REFUND_FIELD, PROFIT_COOP_FIELD, PROFIT_COGS_FIELD, PROFIT_OTHER_COSTS_FIELD, PROFIT_ADVERTISING_COSTS_FIELD]
      }
    };
  },
  computed: {
    getChartConfig() {
      const chart = this.$refs?.chart?.$refs?.chart?.chart;
      if (!chart) return null;
      return {
        type: chart.config.type,
        data: structuredClone(chart.data),
        options: structuredClone(chart.options)
      };
    }
  },
  methods: {
    /**
     * Deep merge default and user options
     * Keeps consistent font, tooltip, etc.
     */
    mergeChartOptions(defaultOptions, customOptions = {}) {
      return R.mergeDeepRight(defaultOptions, customOptions);
    },
    /**
     * Export chart to PNG
     * @param {Object} opts
     * @param {String} [opts.fileName='chart.png'] - Filename for download
     * @param {Boolean} [opts.includeIndicators=false] - Whether to capture wrapper with indicators
     */
    async exportChart({
      includeIndicators = true,
      withBackground = true,
      backgroundColor = "#FFFFFF",
      containerClass = '.evolution-chart-modal .chartter .chart-wrapper',
      exportWidth = 336
    } = {}) {
      try {
        if (!includeIndicators) return;
        const container = document.querySelector(containerClass);
        console.log("Container", container);
        if (!container) {
          window.$bus.trigger("showError", {
            visible: true,
            message: "Chart not available for export"
          });
          return;
        }
        const config = {
          pixelRatio: 5,
          style: {
            fontFamily: 'Figtree, sans-serif'
          },
          filter: node => {
            const exclusionClasses = ['chart-toolbar', 'x2-label'];
            return !exclusionClasses.some(cls => node.classList?.contains(cls));
          },
          backgroundColor: withBackground ? backgroundColor : 'transparent'
        };
        const dataUrl = await htmlToImage.toPng(container, config);
        return dataUrl;
      } catch (err) {
        console.error('❌ Chart export failed:', err);
        window.$bus.trigger("showError", {
          visible: true,
          message: "Chart export failed"
        });
      } finally {}
    },
    async downloadChart({
      fileName = 'chart.png',
      includeIndicators = true
    } = {}) {
      const dataUrl = await this.exportChart({
        includeIndicators
      });
      if (dataUrl) {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = fileName;
        link.click();
      }
    },
    async copyChart(options) {
      console.log("copyChart", options);
      const dataUrl = await this.exportChart({
        includeIndicators: true,
        ...options
      });
      if (dataUrl) {
        await copyImageToClipboard(dataUrl);
      } else {
        throw new Error("Failed to export chart for copying.");
      }
    }
  }
};